import { z } from "zod";

export const tipoServicioEnum = ["wireless", "fiber"] as const;
export type TipoServicio = (typeof tipoServicioEnum)[number];

const optionalPositiveInt = (max: number) =>
  z.union([z.coerce.number().int().positive().max(max), z.literal(""), z.null()]).optional();

export const planCreateSchema = z.object({
  nombre: z.string().min(1, "Requerido").max(100),
  descripcion: z.string().optional().or(z.literal("")),
  tipo_servicio: z.enum(tipoServicioEnum),
  velocidad_down_mbps: z.coerce.number().int().positive().max(100_000),
  velocidad_up_mbps: z.coerce.number().int().positive().max(100_000),
  precio: z.coerce.number().nonnegative(),
  moneda: z.string().length(3).default("MXN"),
  rate_limit_profile: z.string().max(50).optional().or(z.literal("")),
  periodicidad_dias: z.coerce.number().int().positive().max(365).default(30),
  // Ráfagas (opcionales)
  burst_down_mbps: optionalPositiveInt(100_000),
  burst_up_mbps: optionalPositiveInt(100_000),
  burst_threshold_down_mbps: optionalPositiveInt(100_000),
  burst_threshold_up_mbps: optionalPositiveInt(100_000),
  burst_time_s: optionalPositiveInt(86_400),
  // Reuso (contention)
  reuso_ratio: z.coerce.number().int().min(1).max(100).default(1),
  orden: z.coerce.number().int().nonnegative().default(0),
  tags: z.array(z.string()).default([]),
});

export const planUpdateSchema = planCreateSchema.partial().extend({
  activo: z.boolean().optional(),
});

export type PlanCreateInput = z.infer<typeof planCreateSchema>;
export type PlanUpdateInput = z.infer<typeof planUpdateSchema>;

export type Plan = {
  id: string;
  nombre: string;
  descripcion: string | null;
  tipo_servicio: TipoServicio;
  velocidad_down_mbps: number;
  velocidad_up_mbps: number;
  precio: string;
  moneda: string;
  rate_limit_profile: string | null;
  periodicidad_dias: number;
  burst_down_mbps: number | null;
  burst_up_mbps: number | null;
  burst_threshold_down_mbps: number | null;
  burst_threshold_up_mbps: number | null;
  burst_time_s: number | null;
  reuso_ratio: number;
  activo: boolean;
  orden: number;
  tags: string[];
  created_at: string;
  updated_at: string;
  // rc18: número de contratos activos+suspendidos asociados al plan.
  // Se muestra en la lista como "X clientes" y bloquea el delete si > 0.
  contratos_count: number;
};

export type PagedPlanes = {
  items: Plan[];
  total: number;
  page: number;
  size: number;
  pages: number;
};
